module.exports = __webpack_public_path__ + "static/media/dots.46ac226c.svg";